import { Injectable, EventEmitter } from '@angular/core'
import { M3Procesos } from '../Registro/m3-procesos';
import PouchDB from 'pouchdb';
import 'rxjs/add/operator/map';

@Injectable({
    providedIn: 'root'
})
export class M3Data {
    public oDataM3Procesos: M3Procesos;

    private isInstantiated: boolean;
    private database: any;
    private listener: EventEmitter<any> = new EventEmitter();

    constructor() {
        if (!this.isInstantiated) {
            this.database = new PouchDB("CarritoCompras", { auto_compaction: true });
            //this.database = new PouchDB(this.GetServer() + "carrito");
            //this.sync(this.GetServer() + "carrito");
            this.isInstantiated = true;
        }
    }

    public GetServer(): string {
        //var json = require('../../../assets/Config/config.json');
        var json = require('G:/Desarrollo/BD/WE8/config.json');
        return json.CouchDBM3;
    }

    public get(id: string) {
        return this.database.get(id);
    }

    //Adicionar en BD pouch.
    public AddToPouchBDCarritoCompras(id: string, document: any) {
        document._id = id;
        return this.get(id).then(result => {
            document._rev = result._rev;
            return this.database.put(document);
        }, error => {
            if (error.status == "404") {
                return this.database.put(document);
            } else {
                return new Promise((resolve, reject) => {
                    reject(error);
                });
            }
        });

    }

    //Adicionar en BD pouch, Async.
    public async AddToPouchBDCarritoComprasAsync(id: string, document: any) {
        document._id = id;
        try {
            var result = await this.get(id);
            document._rev = result._rev;
            await this.database.put(document);
        } catch (error) {
            if (error.status == "404") {
                await this.database.put(document);
            } else {
                return new Promise((resolve, reject) => {
                    reject(error);
                });
            }
        }

        // return this.get(id).then(result => {
        //     document._rev = result._rev;
        //     return this.database.put(document);
        // }, error => {
        //     if (error.status == "404") {
        //         return this.database.put(document);
        //     } else {
        //         return new Promise((resolve, reject) => {
        //             reject(error);
        //         });
        //     }
        // });
    }


    //Obtener informacion de base de datos.
    public GetDataPouchBD(isKey: string) {
        return this.database.get(isKey);
    }

    //Obtener informacion de base de datos.
    public Delete(isKey: string) {
        this.database.get(isKey).then(result => {
            return this.database.remove(result);
        });
    }


    public getChangeListener() {
        return this.listener;
    }

    public sync(remote: string) {
        let remoteDatabase = new PouchDB(remote, { auto_compaction: true });

        let options = {
            retry: true
        };

        let options2 = {
            live: true,
            retry: true
        };

        //this.autenticacionServer(remoteDatabase);
        this.database.sync(remoteDatabase, {
            options
        }).on('complete', change => {
            this.database.sync(remoteDatabase, options2);
        }).on('change', change => {
            this.listener.emit(change);
        }).on('error', error => {
            this.database.sync(remoteDatabase, options2);
        });
    }




    //armar key de carrito de compras, teniendo en cuenta el IDKatios, tdoc y ndoc.
    public GetKeyCarritoCompras(isIDKatios: string, isTdoc: string, isNdoc: string, isUbicacion: string, isIdHub: string) {
        return "CC?" + isIDKatios + "?" + isUbicacion + "?" + isIdHub + "?" + isTdoc + "?" + isNdoc;
    }

    //Destruir y reconstruir la base de datos pouchDB
    public ReserBD() {
        this.database.destroy().then(x => {
            this.database = new PouchDB('CarritoCompras', { auto_compaction: true });
        });
    }


}
